import { AlertTriangle, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/Button";

type TDataGridErrorProps = {
  message: string;
  onRetry: () => void;
};

/** Actionable error state with a retry that calls refetch. */
export function DataGridError({ message, onRetry }: TDataGridErrorProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center"
    >
      <AlertTriangle className="h-10 w-10 text-destructive" />
      <div className="space-y-1">
        <p className="text-sm font-semibold text-foreground">Something went wrong</p>
        <p className="max-w-md text-sm text-muted-foreground">{message}</p>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={onRetry}
      >
        <RefreshCw className="mr-2 h-4 w-4" />
        Retry
      </Button>
    </div>
  );
}
